const ARTICULOS_COMBUSTIBLE = [
  {
    idArticulo: 2,
    descripcion: "NAFTA SUPER XXI",
    esCombustible: true,
    colorARGB: 0,
    esLubricante: false,
    grupoDescripcion: "NAFTA SUPER XXI",
    familiaDescripcion: "COMBUSTIBLES",
    codigo: "       1",
    liquidaIVA: true,
    alicuotaIVA: 21,
    costo: 1,
    precioPublico: 1279,
    caja: "PLAYA LAPOSTA",
    stockManual: false,
    unidades: 0,
    unidadMedida: null,
    proveedor: "YPF SA",
    proveedorAlternativo: null,
    precioLista1: 0,
    precioLista2: 0,
    precioLista3: 0,
    precioLista4: 0,
    precioLista5: 0,
    precioLista6: 0,
    cuentaContableNeto: 4010101,
    cuentaContableImpuestoInterno: 0,
    cuentaContableTasas: 0,
    cuentaContableCostoNeto: 0,
    cuentaContableCostoImpuestoInterno: 0,
    cuentaContableCompraNeto: 0,
    cuentaContableCompraImpuestoInterno: 0,
    cuentaContableImpuestoInternoConsignado: 4010101,
    cuentaContableTasasConsignado: 4010101,
    cuentaContableVariacionInventario: 0,
    codigoBarra: "",
    activo: true,
    idCaja: 1,
    codigoYPF: null,
    pideDepositoAlFacturar: false,
  },
  {
    idArticulo: 3,
    descripcion: "INFINIA",
    esCombustible: true,
    colorARGB: 0,
    esLubricante: false,
    grupoDescripcion: "INFINA",
    familiaDescripcion: "COMBUSTIBLES",
    codigo: "       2",
    liquidaIVA: true,
    alicuotaIVA: 21,
    costo: 1,
    precioPublico: 1499,
    caja: "PLAYA LAPOSTA",
    stockManual: false,
    unidades: 0,
    unidadMedida: null,
    proveedor: "YPF SA",
    proveedorAlternativo: null,
    precioLista1: 0,
    precioLista2: 0,
    precioLista3: 0,
    precioLista4: 0,
    precioLista5: 0,
    precioLista6: 0,
    cuentaContableNeto: 4010101,
    cuentaContableImpuestoInterno: 0,
    cuentaContableTasas: 0,
    cuentaContableCostoNeto: 0,
    cuentaContableCostoImpuestoInterno: 0,
    cuentaContableCompraNeto: 0,
    cuentaContableCompraImpuestoInterno: 0,
    cuentaContableImpuestoInternoConsignado: 4010101,
    cuentaContableTasasConsignado: 4010101,
    cuentaContableVariacionInventario: 0,
    codigoBarra: "",
    activo: true,
    idCaja: 1,
    codigoYPF: null,
    pideDepositoAlFacturar: false,
  },
  {
    idArticulo: 4,
    descripcion: "GO-INFINIA DIESEL",
    esCombustible: true,
    colorARGB: 0,
    esLubricante: false,
    grupoDescripcion: "GO-INFINIA DIESEL",
    familiaDescripcion: "COMBUSTIBLES",
    codigo: "       3",
    liquidaIVA: true,
    alicuotaIVA: 21,
    costo: 1,
    precioPublico: 1438,
    caja: "PLAYA LAPOSTA",
    stockManual: false,
    unidades: 0,
    unidadMedida: null,
    proveedor: "YPF SA",
    proveedorAlternativo: null,
    precioLista1: 0,
    precioLista2: 0,
    precioLista3: 0,
    precioLista4: 0,
    precioLista5: 0,
    precioLista6: 0,
    cuentaContableNeto: 4010101,
    cuentaContableImpuestoInterno: 0,
    cuentaContableTasas: 0,
    cuentaContableCostoNeto: 0,
    cuentaContableCostoImpuestoInterno: 0,
    cuentaContableCompraNeto: 0,
    cuentaContableCompraImpuestoInterno: 0,
    cuentaContableImpuestoInternoConsignado: 4010101,
    cuentaContableTasasConsignado: 4010101,
    cuentaContableVariacionInventario: 0,
    codigoBarra: "",
    activo: true,
    idCaja: 1,
    codigoYPF: null,
    pideDepositoAlFacturar: false,
  },
  {
    idArticulo: 5,
    descripcion: "D. DIESEL 500",
    esCombustible: true,
    colorARGB: 0,
    esLubricante: false,
    grupoDescripcion: "D. DIESEL 500",
    familiaDescripcion: "COMBUSTIBLES",
    codigo: "       4",
    liquidaIVA: true,
    alicuotaIVA: 21,
    costo: 1,
    precioPublico: 1253,
    caja: "PLAYA LAPOSTA",
    stockManual: false,
    unidades: 0,
    unidadMedida: null,
    proveedor: "YPF SA",
    proveedorAlternativo: null,
    precioLista1: 0,
    precioLista2: 0,
    precioLista3: 0,
    precioLista4: 0,
    precioLista5: 0,
    precioLista6: 0,
    cuentaContableNeto: 4010101,
    cuentaContableImpuestoInterno: 0,
    cuentaContableTasas: 0,
    cuentaContableCostoNeto: 0,
    cuentaContableCostoImpuestoInterno: 0,
    cuentaContableCompraNeto: 0,
    cuentaContableCompraImpuestoInterno: 0,
    cuentaContableImpuestoInternoConsignado: 4010101,
    cuentaContableTasasConsignado: 4010101,
    cuentaContableVariacionInventario: 0,
    codigoBarra: "",
    activo: true,
    idCaja: 1,
    codigoYPF: null,
    pideDepositoAlFacturar: false,
  },
  {
    idArticulo: 81,
    descripcion: "SUPER 20W50 GR",
    esCombustible: true,
    colorARGB: 0,
    esLubricante: true,
    grupoDescripcion: "SUPER 20W50 G",
    familiaDescripcion: "LUBRICANTES",
    codigo: "       6",
    liquidaIVA: true,
    alicuotaIVA: 21,
    costo: 78.5999,
    precioPublico: 5000,
    caja: "PLAYA LAPOSTA",
    stockManual: false,
    unidades: 0,
    unidadMedida: null,
    proveedor: null,
    proveedorAlternativo: null,
    precioLista1: 0,
    precioLista2: 0,
    precioLista3: 0,
    precioLista4: 0,
    precioLista5: 0,
    precioLista6: 0,
    cuentaContableNeto: 0,
    cuentaContableImpuestoInterno: 0,
    cuentaContableTasas: 0,
    cuentaContableCostoNeto: 0,
    cuentaContableCostoImpuestoInterno: 0,
    cuentaContableCompraNeto: 0,
    cuentaContableCompraImpuestoInterno: 0,
    cuentaContableImpuestoInternoConsignado: 0,
    cuentaContableTasasConsignado: 0,
    cuentaContableVariacionInventario: 0,
    codigoBarra: "",
    activo: true,
    idCaja: 1,
    codigoYPF: null,
    pideDepositoAlFacturar: false,
  },
  {
    idArticulo: 104,
    descripcion: "HD SUPLEMENTO 1 40 GR GNC",
    esCombustible: true,
    colorARGB: 0,
    esLubricante: true,
    grupoDescripcion: "HD SUPLEMENTO 1 40 GR",
    familiaDescripcion: "LUBRICANTES",
    codigo: "       7",
    liquidaIVA: true,
    alicuotaIVA: 21,
    costo: 62.7,
    precioPublico: 4000,
    caja: "PLAYA LAPOSTA",
    stockManual: false,
    unidades: 0,
    unidadMedida: null,
    proveedor: null,
    proveedorAlternativo: null,
    precioLista1: 0,
    precioLista2: 0,
    precioLista3: 0,
    precioLista4: 0,
    precioLista5: 0,
    precioLista6: 0,
    cuentaContableNeto: 4010102,
    cuentaContableImpuestoInterno: 0,
    cuentaContableTasas: 0,
    cuentaContableCostoNeto: 0,
    cuentaContableCostoImpuestoInterno: 0,
    cuentaContableCompraNeto: 0,
    cuentaContableCompraImpuestoInterno: 0,
    cuentaContableImpuestoInternoConsignado: 0,
    cuentaContableTasasConsignado: 0,
    cuentaContableVariacionInventario: 0,
    codigoBarra: "",
    activo: true,
    idCaja: 1,
    codigoYPF: null,
    pideDepositoAlFacturar: false,
  },
  {
    idArticulo: 1438,
    descripcion: "GNC",
    esCombustible: true,
    colorARGB: 0,
    esLubricante: false,
    grupoDescripcion: "GNC",
    familiaDescripcion: "COMBUSTIBLES",
    codigo: "       5",
    liquidaIVA: true,
    alicuotaIVA: 21,
    costo: 1,
    precioPublico: 569,
    caja: "PLAYA LAPOSTA",
    stockManual: false,
    unidades: 0,
    unidadMedida: null,
    proveedor: null,
    proveedorAlternativo: null,
    precioLista1: 0,
    precioLista2: 0,
    precioLista3: 0,
    precioLista4: 0,
    precioLista5: 0,
    precioLista6: 0,
    cuentaContableNeto: 4010104,
    cuentaContableImpuestoInterno: 4010104,
    cuentaContableTasas: 4010104,
    cuentaContableCostoNeto: 0,
    cuentaContableCostoImpuestoInterno: 0,
    cuentaContableCompraNeto: 0,
    cuentaContableCompraImpuestoInterno: 0,
    cuentaContableImpuestoInternoConsignado: 0,
    cuentaContableTasasConsignado: 0,
    cuentaContableVariacionInventario: 0,
    codigoBarra: "",
    activo: true,
    idCaja: 1,
    codigoYPF: null,
    pideDepositoAlFacturar: false,
  },
];
const getCombustibles = async () => {
  return ARTICULOS_COMBUSTIBLE;
};

const combustibles = {
  getCombustibles,
};

export default combustibles;
